module.exports = __webpack_public_path__ + "static/media/victory.08553302.mp3";